import React from 'react';
import { ThumbsUp, ThumbsDown, User } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Message } from '@/types/chat';

interface ChatMessageProps {
  message: Message;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.role === 'user';

  return (
    <div className={`py-5 ${isUser ? 'bg-white' : 'bg-muted/40'}`}>
      <div className="max-w-3xl mx-auto flex gap-4">
        <div className="flex-shrink-0">
          {isUser ? (
            <Avatar className="h-8 w-8 border border-border">
              <AvatarFallback className="bg-brand-roxo/10 text-brand-azul">
                <User className="h-4 w-4" />
              </AvatarFallback>
            </Avatar>
          ) : (
            <Avatar className="h-8 w-8 bg-brand-azul flex items-center justify-center">
              <AvatarImage src="/brand/icone-rosa.svg" alt="dgenny" className="p-1.5" />
              <AvatarFallback className="bg-brand-azul text-brand-rosa font-bold">d</AvatarFallback>
            </Avatar>
          )}
        </div>

        <div className="flex-1">
          <div className="font-semibold text-sm text-brand-azul">
            {isUser ? 'Você' : 'dgenny'}
          </div>

          <div className="mt-1.5 text-brand-azul/90 whitespace-pre-wrap leading-relaxed">
            {message.content}
          </div>

          {!isUser && (
            <div className="flex items-center mt-3 gap-1.5">
              <button className="p-1 rounded-md hover:bg-muted transition-colors" aria-label="Like">
                <ThumbsUp className="h-4 w-4 text-brand-azul/50" />
              </button>
              <button className="p-1 rounded-md hover:bg-muted transition-colors" aria-label="Dislike">
                <ThumbsDown className="h-4 w-4 text-brand-azul/50" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatMessage;
